import { useLinkTo, useNavigation, useRoute } from '@react-navigation/native';
import { TouchableOpacity, View } from 'react-native';
import { useSelector } from 'react-redux';
import { RootState } from 'store/index';
import { isMobile } from 'utils/deviceInfo';

import MenuArea from './MenuArea';

import { Icons } from 'components/Icons';

const HeaderMenuRightArea: React.FC = () => {
  const route = useRoute();
  const linkTo = useLinkTo();
  const navigation = useNavigation<any>();
  const user = useSelector((state: RootState) => state.auth);

  const handleSearchPress = () => (isMobile ? navigation.navigate('Search') : linkTo('/buscar'));

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          paddingHorizontal: 5,
          gap: 24,
        }}>
        {route.name !== 'Search' && (
          <View style={{ borderWidth: 1, borderColor: 'transparent' }}>
            <TouchableOpacity
              style={{
                width: 15,
                height: 25,
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onPress={handleSearchPress}>
              <Icons.MagnifyinGlass height="22" width="22" />
            </TouchableOpacity>
          </View>
        )}
        <MenuArea userData={user} />
      </View>
    </>
  );
};

export default HeaderMenuRightArea;
